import { Controller } from "@hotwired/stimulus"

// Banner de consentimento de cookies (LGPD).
// "Aceitar" grava o consentimento e recarrega a página para que os tags de
// marketing (Meta Pixel, RD Station, Google Ads) passem a ser renderizados.
// "Recusar" registra a recusa e apenas remove o banner — nenhum tag carrega.
export default class extends Controller {
  accept() {
    this.setConsent("granted")
    window.location.reload()
  }

  decline() {
    this.setConsent("denied")
    this.element.remove()
  }

  setConsent(value) {
    const maxAge = 60 * 60 * 24 * 180 // 180 dias
    let cookie = `cookie_consent=${value}; path=/; max-age=${maxAge}; SameSite=Lax`
    if (window.location.protocol === "https:") cookie += "; Secure"
    document.cookie = cookie
  }
}
